module.exports = __webpack_public_path__ + "img/hc_pro_four_5.e0124994.jpg";